import "./HealthSafetyAccreditations.module.css";
import Header from "@/reusable_sections/Header";
import Safety from "./sections/Safety";
import Accreditations from "./sections/Accreditations";
import Documentation from "./sections/Documentation";
import Footer from "@/reusable_sections/Footer";
export default function HealthSafetyAccreditationsPage() {
  return <div>
      <Header />
      <Safety />
      <Accreditations />
      <Documentation />
      <Footer />
    </div>;
}